import { render, staticRenderFns } from "./YA_AboutPricing.vue?vue&type=template&id=43c041c9&scoped=true"
import script from "./YA_AboutPricing.vue?vue&type=script&lang=js"
export * from "./YA_AboutPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c041c9",
  null
  
)

export default component.exports